module.exports = __webpack_public_path__ + "static/media/bakery_image3.c187d645.png";